export const API_BASE_URL = 'https://developerapi.dbtouch.com';

export const formatEuri = (iznos) => {
  return new Intl.NumberFormat('hr-HR', { 
    style: 'currency', 
    currency: 'EUR', 
    maximumFractionDigits: 0 
  }).format(iznos);
};